/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useViewingContext } from '../contexts/ViewingContext';
import CenteredEnvelope from '../components/CenteredEnvelope';
import EnvelopeWithBox from '../components/EnvelopeWithBox';
import BorrowerSelectLoans from '../components/forms/BorrowerSelectLoans';
import ServicerSearchLoans from '../components/forms/ServicerSearchLoans';
import { SnackbarProvider } from 'notistack';

const SelectLoansPage = () => {
  const { isServicerView } = useViewingContext();
  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={2500}
      preventDuplicate
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      {isServicerView ? (
        <EnvelopeWithBox blockName='Search Loans' disabled={false}>
          <ServicerSearchLoans></ServicerSearchLoans>
        </EnvelopeWithBox>
      ) : (
        <BorrowerSelectLoans />
      )}
    </SnackbarProvider>
  );
};

export default SelectLoansPage;
